import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		// NOTE: router内でエラーの出し分けをするときに使用
		// {
		// 	path: '/error',
		// 	name: 'Error',
		// 	component: () => import(/* webpackChunkName: "SorryPage" */ '@/views/SorryPage'),
		// 	props: {
		// 		text: 'サーバーで問題が発生しているため、ページを表示できません。<br>しばらく時間を置いてからやり直してください。'
		// 	}
		// },
		// // ソーリーページ（非対応端末エラー）
		// {
		// 	path: '/sorryPage',
		// 	name: 'SorryPage',
		// 	component: () => import(/* webpackChunkName: "SorryPage" */ '@/views/SorryPage'),
		// 	props: {
		// 		text: '申し訳ございません。<br>お使いの端末ではこのサービスをご利用いただけません。'
		// 	}
		// },
		// 404 NotFound
		{
			path: `/`,
			name: 'Top',
			component: () => import(/* webpackChunkName: "Top" */ '@/views/Top')
		},
		// ネイティブアプリwebview用痛みノートカレンダー
		{
			path: '/webviewPainNoteCalendar',
			name: 'WebviewPainNoteCalendar',
			component: () => import(/* webpackChunkName: "WebviewPainNoteCalendar" */ '@/views/WebviewPainNoteCalendar')
		},
		// ネイティブアプリwebview用痛みノートリスト
		{
			path: '/webviewPainNoteList',
			name: 'WebviewPainNoteList',
			component: () => import(/* webpackChunkName: "WebviewPainNoteList" */ '@/views/WebviewPainNoteList')
		},
		// ネイティブアプリwebview用痛みレポート
		{
			path: '/webviewPainNoteReport',
			name: 'WebviewPainNoteReport',
			component: () => import(/* webpackChunkName: "WebviewPainNoteReport" */ '@/views/WebviewPainNoteReport')
		},
		// ネイティブアプリwebview用プロフィール画面の「生理」
		{
			path: '/webviewProfileMenstruationTop',
			name: 'WebviewProfileMenstruationTop',
			component: () => import(/* webpackChunkName: "WebviewProfileMenstruationTop" */ '@/views/WebviewProfileMenstruationTop')
		},
		// ネイティブアプリwebview用プロフィール画面の「痛みノート 生理日一覧」
		{
			path: '/webviewProfileMenstruationList',
			name: 'WebviewProfileMenstruationList',
			component: () => import(/* webpackChunkName: "WebviewProfileMenstruationList" */ '@/views/WebviewProfileMenstruationList')
		},
		// ネイティブアプリwebview用天気予報
		{
			path: '/webviewWeatherForecast',
			name: 'WebviewWeatherForecast',
			component: () => import(/* webpackChunkName: "WebviewWeatherForecast" */ '@/views/WebviewWeatherForecast')
		},
		// ネイティブアプリwebview用Fitbitレポート
		{
			path: '/webviewFitbitReport',
			name: 'WebviewFitbitReport',
			component: () => import(/* webpackChunkName: "WebviewFitbitReport" */ '@/views/WebviewFitbitReport')
		},
		// ネイティブアプリwebview用プロフィール画面のFitbit
		{
			path: '/webviewProfileFitbit',
			name: 'WebviewProfileFitbit',
			component: () => import(/* webpackChunkName: "WebviewProfileFitbit" */ '@/views/WebviewProfileFitbit')
		},
		// ネイティブアプリwebview用おしえてAI結果画面
		{
			path: '/webviewPainTypeAiResult',
			name: 'WebviewPainTypeAiResult',
			component: () => import(/* webpackChunkName: "WebviewPainTypeAiResult" */ '@/views/WebviewPainTypeAiResult')
		},
		// ネイティブアプリwebview用お知らせ画面
		{
			path: '/webviewNotice',
			name: 'WebviewNotice',
			component: () => import(/* webpackChunkName: "WebviewNotice" */ '@/views/WebviewNotice')
		},
		// ネイティブアプリペット散歩画面
		{
			path: '/webviewPetWalking',
			name: 'WebviewPetWalking',
			component: () => import(/* webpackChunkName: "WebviewPetWalking" */ '@/views/WebviewPetWalking')
		},
		// ネイティブアプリペット天気画面
		{
			path: '/webviewPetWeather',
			name: 'WebviewPetWeather',
			component: () => import(/* webpackChunkName: "WebviewPetWeather" */ '@/views/WebviewPetWeather')
		},
		// ネイティブアプリペット指数画面
		{
			path: '/webviewPetSummary',
			name: 'WebviewPetSummary',
			component: () => import(/* webpackChunkName: "WebviewPetSummary" */ '@/views/WebviewPetSummary')
		},
		// 404 NotFound
		{
			path: `/*`,
			name: 'NotFound',
			component: () => import(/* webpackChunkName: "SorryPage" */ '@/views/SorryPage'),
			props: {
				text: '申し訳ございません。<br>お探しのページは見つかりません。'
			}
		}
		// TODO: その他開発時に追記
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
})

// ナビゲーションガード
router.beforeEach((to, from, next) => {
	if (!store.getters['common/veiwMode']) store.dispatch('common/SET_VIEW_MODE', 'ausp')
	next()
})

export default router
